import { decode, JwtPayload } from "jsonwebtoken";
import { JwtTokens } from "./jwt-tokens";

const getDate = (secondsSinceUnixEpoch?: number) => {
    if (!secondsSinceUnixEpoch) {
        return undefined;
    }

    return new Date(secondsSinceUnixEpoch * 1000);
}

const definedAndEqual = (a: string | undefined, b: string | undefined) => {
    return (!!a && !!b && a === b);
}

class BaseDecodedJwtToken {
    protected _jwt: JwtPayload;

    id?: string;
    issuer?: string;
    clientId?: string;
    expiration?: Date;
    issuedAt?: Date;

    constructor(token: string) {
        if (!token) {
            this._jwt = {};
            return;
        }

        const jwt = decode(token) as JwtPayload;

        this.id = jwt.jti;
        this.clientId = jwt.sub;
        this.issuer = jwt.iss;
        this.expiration = getDate(jwt?.exp);
        this.issuedAt = getDate(jwt?.iat);

        this._jwt = jwt;
    }

    get isExpired() {
        if (!this.expiration || !this.issuedAt) {
            return true;
        }

        return this.expiration < new Date();
    }
}

export class DecodedIdToken extends BaseDecodedJwtToken {
    connectId?: string;
    email?: string;
    mobile?: string;

    constructor(idToken: string) {
        super(idToken);

        const jwt = this._jwt;

        this.connectId = jwt?.sub;
        this.email = jwt["email"];
        this.mobile = jwt["mobile"]
    }
}

export class DecodedAccessToken extends BaseDecodedJwtToken {
    idTokenId?: string;
    connectId?: string;
    country?: string;

    constructor(accessToken: string) {
        super(accessToken);

        const jwt = this._jwt;

        this.idTokenId = jwt["idTokenJTI"];
        this.connectId = jwt?.sub;
        this.country = jwt["country"];
    }
}


export class DecodedJwtTokens {
    access: DecodedAccessToken;
    id: DecodedIdToken;
    isValid: boolean;

    constructor(tokens: JwtTokens) {
        const access = new DecodedAccessToken(tokens.accessToken);
        const id = new DecodedIdToken(tokens.idToken);

        this.access = access;
        this.id = id;

        this.isValid = definedAndEqual(access.clientId, id.clientId) && definedAndEqual(access.idTokenId, id.id);
    }
}
